// extracted by mini-css-extract-plugin
export default {"mainPageContainer":"operations-page_mainPageContainer__god9f","hiddenMainPage":"operations-page_hiddenMainPage__L6qii","loader":"operations-page_loader__irPZA"};